import countries from "i18n-iso-countries";
import en from "i18n-iso-countries/langs/en.json";

countries.registerLocale(en);

export const countryOptions = Object.entries(
  countries.getAlpha2Codes()
)
  .map(([code, name]) => ({
    code: code.toUpperCase(),
    name,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));